
import { createMuiTheme } from '@material-ui/core/styles';

const fonts = {
  header: [
    'Hind',
    'Helvetica',
    'Arial',
    'Lucida',
    'sans-serif',
  ].join(','),
  body: [
    '"Open Sans"',
    'Helvetica',
    'Arial',
    'Lucida',
    'sans-serif',
  ].join(','),
};

const palette = {
  primary: {
    main: '#303d50',
  },
  secondary: {
    main: '#afc8bb',
  },
};

const theme = createMuiTheme({
  typography: {
    fontFamily: fonts.header,
    h1: {
      fontSize: 36,
      fontWeight: 600,
    },
    h2: {
      fontSize: 36,
      fontWeight: 600,
      color: palette.primary.main,
    },
    h3: {
      fontSize: 24,
      color: palette.primary.main,
    },
    body1: {
      fontFamily: fonts.body,
    },
    body2: {
      fontFamily: fonts.body,
    },
    button: {
      textTransform: 'none',
    },
  },
  palette,
});

export default theme;
